<div class="contenido">
    <div class="row secc1">
        <div class="col left">
            <div class="login">
                <div class="title">
                    <h3 *ngIf="!forg">Iniciar Sesión</h3>
                    <h3 *ngIf="forg">Recuperar Contraseña</h3>
                </div>
                <div class="formul" *ngIf="!forg">
                    <form action="" [formGroup]="loginForm" (ngSubmit)="send()">
                        <div class="inp-user">
                            <input class="inputs" type="input" name="user" id="user" formControlName="usuario" required />
                            <label for="user" alt="Usuario" placeholder="Usuario"></label>
                        </div>
                        <!-- <div *ngIf="usuario.invalid && (usuario.dirty || usuario.touched)" class="alert alert-danger">
                            <div *ngIf="usuario.errors.required">
                                User is required.
                            </div>
                        </div> -->
                        <div class="inp-pass">
                            <input class="inputs" type="password" name="pass" id="pass" formControlName="psw" autocomplete="off" required />
                            <label for="pass" alt="Contraseña" placeholder="Contraseña"></label>
                        </div>
                        <!-- <div *ngIf="psw.invalid && (psw.dirty || psw.touched)" class="alert alert-danger">
                            <div *ngIf="psw.errors.required">
                                Pass is required.
                            </div>
                        </div> -->
                        <!-- <div class="form__group field">
                            <input formControlName="recordarme" type="checkbox" name="remember" id="remember">
                            <label for="remember">Recordar Usuario</label>
                        </div> -->
                        <div class="cont-btn">
                            <button type="submit" class="btn" [disabled]="!loginForm.valid">Iniciar Sesión</button>
                        </div>
                    </form>
                </div>
                <div class="forgot" *ngIf="!forg">
                    <span (click)="olvideContrasenna()">¿Olvidaste tu contraseña?</span>
                </div>
                <div class="formul" *ngIf="forg">
                    <form action="" [formGroup]="recoverForm" (ngSubmit)="sendRecover()">
                        <div class="inp-user">
                            <input class="inputs" type="input" name="user2" id="user2" formControlName="usuario" required />
                            <label for="user2" alt="Usuario" placeholder="Usuario"></label>
                        </div>
                        <!-- <div *ngIf="usuario.invalid && (usuario.dirty || usuario.touched)" class="alert alert-danger">
                                            <div *ngIf="usuario.errors.required">
                                                User is required.
                                            </div>
                                        </div> -->
                        <div class="cont-btn">
                            <button type="submit" class="btn" [disabled]="!recoverForm.valid">Recuperar</button>
                        </div>
                    </form>
                </div>
                <!-- <div class="foot">
                    <p>
                        ¿No tienes una cuenta? <a (click)="clickM()">Regístrate</a>
                    </p>
                </div> -->
            </div>
        </div>
        <div class="col right navegador">
            <img class="rectangulo" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Rectangulo-new.png" alt="">
            <img class="logimg" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Login-new.png" alt="">
        </div>
    </div>
</div>